import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable, Observer } from 'rxjs/Rx';
import 'rxjs/add/operator/map'
import { DataService } from '../services/data.service';
import { IDashboardData, IETLData } from '../viewsmodule/interfaces';

import * as moment from 'moment/moment';

@Injectable()
export class DashboardDataUtility {
    public activeDashboard: any;
    
    constructor(private dataService: DataService) { }
    
    getTodayData() {
        let data = this.dataService.dashboardData;
    }

    getWeeklyData(data: any, questionsString: string): Array<any> {
        let questionArray = questionsString.split(',');
        
        let toDate = data.recordSet[0].FromDate;
        let m = moment;
        let resultData = [];
        let tempObj = {};

        let dayOfWeek = moment(toDate).weekday();
        let startDateDayOfWeek = moment(data.recordSet[data.recordSet.length - 1].FromDate).weekday();

        //reduce one day from the week day as default start day of the week for moment is sunday but we here are working with default working day of the week as monday
        if (dayOfWeek === 0) {
            var tempdayOfWeek = 6
        }
        else {
            var tempdayOfWeek = dayOfWeek - 1;
        }

        if (startDateDayOfWeek === 0) {
            var tempstartDateDayOfWeek = 6
        }
        else {
            var tempstartDateDayOfWeek = startDateDayOfWeek - 1;
        }

        //calculation when the startdate and enddate fall on the same week
        if (tempdayOfWeek >= tempstartDateDayOfWeek && data.recordSet.length <= 7) {
            tempObj = this.initializeTempQuestObj(questionArray);
            for (var i = 0; i < data.recordSet.length; i++) {
                for (var j = 0; j < questionArray.length; j++) {
                    tempObj[questionArray[j]] += data.recordSet[i][questionArray[j]];
                }
            }
            tempObj['fromDate'] = moment(data.recordSet[i - 1].FromDate).format("MMM DD, YYYY") + ' - ' + moment(toDate).format("MMM DD, YYYY");
            resultData.push(tempObj);
            return resultData;
        }
        //calculation when the startdate and enddate does not fall on the same week
        else {

            tempObj = this.initializeTempQuestObj(questionArray);
            
            for (var i = 0; i < dayOfWeek; i++) {
                for (var j = 0; j < questionArray.length; j++) {
                    tempObj[questionArray[j]] += data.recordSet[i][questionArray[j]];
                }
            }
            
            tempObj['fromDate'] = moment(data.recordSet[i - 1].FromDate).format("MMM DD, YYYY") + ' - ' + moment(toDate).format("MMM DD, YYYY");
            resultData.push(tempObj);

            let traversedData = i;
            while ((i + 7) < data.recordSet.length) {
                tempObj = this.initializeTempQuestObj(questionArray);
                    
                for (var k = i; k < i + 7; k++) {
                    for (var j = 0; j < questionArray.length; j++) {
                        tempObj[questionArray[j]] += data.recordSet[k][questionArray[j]];
                    }
                }

                i = k;
                tempObj['fromDate'] = moment(data.recordSet[i - 1].FromDate).format("MMM DD, YYYY") + ' - ' + moment(data.recordSet[i - 1].FromDate).add(6, 'days').format("MMM DD, YYYY");
                resultData.push(tempObj);
            }
                
            tempObj = this.initializeTempQuestObj(questionArray);

            for (var l = i; l < data.recordSet.length; l++) {
                for (var j = 0; j < questionArray.length; j++) {
                    tempObj[questionArray[j]] += data.recordSet[l][questionArray[j]];
                }
            }

            tempObj['fromDate'] = moment(data.recordSet[l - 1].FromDate).format("MMM DD, YYYY") + ' - ' + moment(data.recordSet[l - 1].FromDate).add(l - i - 1, 'days').format("MMM DD, YYYY");
            resultData.push(tempObj);
        
            return resultData.reverse();
        }
    }

    getMonthlyData(data: any, questionsString: string): Array<any> {
        let questionArray = questionsString.split(',');
        
        let toDate = data.recordSet[0].FromDate;
        let noOfDaysInCurrentMonth = moment(toDate).date();
        let flag = noOfDaysInCurrentMonth;

        let m = moment;
        let resultData = [];
        let tempObj = {};
        let daysInMonths: Array<number> = [];

        daysInMonths.push(noOfDaysInCurrentMonth);

        //Calculation if startdate and enddate fall on the same month 
        if (data.recordSet.length <= noOfDaysInCurrentMonth) {
            tempObj = this.initializeTempQuestObj(questionArray);
            for (var i = 0; i < data.recordSet.length; i++) {
                for (var j = 0; j < questionArray.length; j++) {
                    tempObj[questionArray[j]] += data.recordSet[i][questionArray[j]];
                }
            }
            tempObj['fromDate'] = moment(data.recordSet[0].FromDate).format("MMMM YYYY");
            resultData.push(tempObj);
        }
        //Calculation if startdate and enddate does not fall on the same month
        else {
            while (flag < data.recordSet.length) {
                let days = this.getDaysInMonths(data.recordSet[flag].FromDate);
                if (flag + days > data.recordSet.length) {
                    daysInMonths.push(data.recordSet.length - flag);
                }
                else {
                    daysInMonths.push(days);
                }

                flag = flag + days;
            }

            flag = 0;
            for (var i = 0; i < daysInMonths.length; i++) {
                tempObj = this.initializeTempQuestObj(questionArray);
                for (var j = flag; j < (flag + daysInMonths[i]); j++) {
                    for (var k = 0; k < questionArray.length; k++) {
                        tempObj[questionArray[k]] += data.recordSet[j][questionArray[k]];
                    }
                }

                flag = flag + daysInMonths[i];
                tempObj['fromDate'] = moment(data.recordSet[j - 1].FromDate).format("MMMM YYYY");
                resultData.push(tempObj);
            }
        }
        return resultData.reverse();
    }

    getDailyData(data: any, questionsString: string): Array<any> {
        let questionArray = questionsString.split(',');
        let tempObj = {};
        let resultData = [];

        for (var i = 0; i < data.recordSet.length; i++) {
            tempObj = this.initializeTempQuestObj(questionArray);
            for (var j = 0; j < questionArray.length; j++) {
                tempObj[questionArray[j]] += data.recordSet[i][questionArray[j]];
            }

            tempObj['fromDate'] = moment(data.recordSet[i].FromDate).format("MMM DD, YYYY");
            resultData.push(tempObj);
        }
        
        return resultData.reverse();
    }

    initializeTempQuestObj(questionArray: any) {
        let tempObj = {};
        for (var j = 0; j < questionArray.length; j++) {
            tempObj[questionArray[j]] = 0;
        }

        return tempObj;
    }

    getDaysInMonths(date: string): number {
        return moment(date).daysInMonth();
    }

    getSeriesQuestionValueSum(data: any, questionArray: Array<string>) {
        let sumData: any = {};

        for (let i = 0; i < questionArray.length; i++) {
            sumData[questionArray[i]] = 0;
        }

        if (data) {
            for (let i = 0; i < data.recordSet.length; i++) {
                for (let j = 0; j < questionArray.length; j++) {
                    sumData[questionArray[j]] += data.recordSet[i][questionArray[j]];
                }
            }
        }

        return sumData;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/utils/data.calculate.ts